import React, { useEffect, useState } from 'react';
import { StanToggle } from '@/components';
import { useUser } from '@/queries/useUser';
import { stanNotify } from '@/lib/stanNotify';
import { useStoreSettings } from '../../queries/useStoreSettings';

export const MarketingConsentSection: React.FC = () => {
    const { user } = useUser();
    const [enabled, setEnabled] = useState(user?.data.marketing_consent?.enabled || false);
    const [showSaved, setShowSaved] = useState(false);
    const { mutateAsync: updateStoreSettingsMutation, isPending } = useStoreSettings();

    useEffect(() => {
        if (user) {
            setEnabled(user.data.marketing_consent?.enabled || false);
        }
    }, [user?.data.marketing_consent?.enabled]);

    const handleToggleChange = async (checked: boolean) => {
        setEnabled(checked);

        try {
            await updateStoreSettingsMutation({ marketing_consent_enabled: checked });

            setShowSaved(true);
            setTimeout(() => {
                setShowSaved(false);
            }, 2000);

            stanNotify({
                type: 'success',
                title: 'Success!',
                text: 'Settings have been saved.',
            });
        } catch (error: any) {
            console.error('Settings update error:', error);

            stanNotify({
                type: 'error',
                title: 'Something went wrong',
                text: error?.response?.data?.message || 'Please try again later.',
            });
        }
    };

    return (
        <div className='max-w-3xl'>
            <div className='mb-0'>
                <div className='mb-2 flex items-center gap-2'>
                    <h4>Enable Marketing Consent (GDPR)</h4>
                    <StanToggle
                        checked={enabled}
                        onChange={e => handleToggleChange(e.target.checked)}
                        disabled={isPending}
                    />
                    {isPending && <span className='text-caption-1-regular text-gray'>Saving...</span>}
                    {showSaved && !isPending && <span className='text-caption-1-regular text-gray'>Saved!</span>}
                </div>
                <p className='text-caption-1-regular text-gray'>
                    Selling to EU or UK customers? This helps keep things GDPR-friendly. When enabled, only customers
                    who check the box can get marketing emails. Optional, but recommended if you&apos;ve got a global
                    audience.
                </p>
            </div>
        </div>
    );
};
